const initialState = {
  itemData: {
    data: null,
    error: null,
    fetching: false,
  },
};
export default initialState;
